import { isNotNull } from 'utils/tsHelpers';

export const htmlCollectionToArray = <E extends Element>(collection: HTMLCollectionOf<E>) => {
  const elements: E[] = [];
  for (let i = 0; i < collection.length; i++) {
    const element = collection.item(i);
    if (isNotNull(element)) elements.push(element);
  }
  return elements;
};
